<template>
    <div class="pb-8 md:pb-20">
        <h1 class="text-4xl uppercase text-center pb-1.5 md:pb-3.5 md:pt-6 overflow-auto">horse shows</h1>
        <hr/>
        <div class="text-center py-7" v-if="ready">
          <select v-model="month" class="mt-1 py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"  @change="getData">
            <option value="0">Select All</option>
            <option :value="month.month" v-for="month in months">{{ new Intl.DateTimeFormat('default', {    timeZone: 'utc',month: 'long'}).format(new Date(month.month+'/13/2000'))}}</option>
          </select>
          <select v-model="year" class="mt-1 py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" @change="getData">
            <option :value="year.year" v-for="year in years">{{year.year}}</option>
          </select>
<!--          <a href="#" class="bg-black text-white uppercase text-xs p-1.5">go</a>-->
        </div>
        <div v-else>
          <loaders-spinner />
        </div>
        <HorseShowsExcerpt :title="show.title" :albums="show.albums" :judge_cards="show.judge_cards" :videos="show.videos" :aa="show.aa" :photo_link="show.photo_link" :location="show.location" :duration="show.duration" :permalink="show.permalink" v-for="show in shows" :key="show.id"/>
    </div>
</template>




<script setup>
  import {ref} from 'vue';
  import {http} from "~/utils/http";

  const year = ref(new Date().getFullYear())
  const years = ref([]);
  const month = ref(0)
  const months = ref([]);
  const shows = ref([]);

  const ready = ref(false);




  const getData = async () => {
    shows.value = [];
    try {
      await http
          .get("/api/event", {
            params: {
              year: year.value,
              month: month.value,
              onlyWithResults: 1,
            },
          })
          .then(async (response) => {
            years.value = response.data.years;
            months.value = response.data.months;
            let check = years.value.map(item => item.year).indexOf(year.value);
            if (check < 0) {
              year.value = years.value[0].year;
              await getData();
              return
            }
            response.data.events.forEach((item) => {
              let aa = false;

              let diff = new Intl.DateTimeFormat('default', {    timeZone: 'utc',day: 'numeric'}).format(new Date(item.date_end)) - new Intl.DateTimeFormat('default', {    timeZone: 'utc',day: 'numeric'}).format(new Date(item.date_start))
              if (item.result.usaf === 1 && item.result.nr_of_horses > 1 && diff >= 2) {
                aa = true;
              }

              shows.value.push({
                id: item.id,
                title: item.name,
                location: item.city + (item.state_province ? (', ' + item.state_province.abbreviation) : ''),
                duration: new Intl.DateTimeFormat('default', {    timeZone: 'utc',
                      month: 'short',
                      day: 'numeric'
                    }).format(new Date(item.date_start)) +
                    ' - ' + new Intl.DateTimeFormat('default', {    timeZone: 'utc',
                      month: 'short',
                      day: 'numeric'
                    }).format(new Date(item.date_end)),
                permalink: item.permalink,
                aa: aa,
                photo_link: item.result.photo_link ?? false,
                videos: item.videos.length > 0,
                judge_cards: item.judge_cards.length > 0,
                albums: item.albums.length > 0,
              })
            });
            ready.value = true;
          });
    } catch (e) {
      console.log(e.response.data.error);
    }
  }

  getData()
</script>
